import React from "react";
import { TiTick } from "react-icons/ti";

export const Stepper = ({ currentStep = 0, steps }) => {
  return (
    <div className="flex justify-center items-center w-full px-4">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        return (
          <React.Fragment key={index}>
            {/* Step Circle + Label */}
            <div className="flex flex-col items-center relative">
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full border-2 z-10
              ${
                isCompleted
                  ? "bg-green-600 border-green-600 text-white"
                  : isActive
                  ? "bg-white border-[#1876A9] text-[#1876A9]"
                  : "bg-white border-gray-300 text-gray-400"
              }`}
              >
                {isCompleted ? (
                  <TiTick className="w-5 h-5" />
                ) : (
                  <span className="text-sm font-semibold">
                    {(index + 1).toString().padStart(2, "0")}
                  </span>
                )}
              </div>
              <div
                className={`mt-1 text-xs font-semibold text-center ${
                  isCompleted
                    ? "text-green-600"
                    : isActive
                    ? "text-[#1876A9]"
                    : "text-gray-400"
                }`}
              >
                {step.label}
              </div>
            </div>
            {/* Connector line */}
            {index !== steps.length - 1 && (
              <div
                className={`flex-1 h-[2px] -mt-3 z-0 ${
                  index === 0
                    ? "-ml-6 -mr-2"
                    : index === steps.length - 2
                    ? "-ml-2 -mr-6"
                    : "-ml-2 -mr-2"
                }`}
              >
                <div
                  className={`h-full ${
                    index < currentStep - 1
                      ? "bg-green-600"
                      : index === currentStep - 1
                      ? "bg-[#1876A9]"
                      : "bg-gray-300"
                  }`}
                ></div>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
